import swal from 'sweetalert2';
import { DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Pagination } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Pagination as LPagination, Switch as LSwitch } from '@/components/index';
const svc = new ResourceSvc();

export default {
    props: ['courseId'],
    name: 'AdminCouponsTab',
    components: {
        LPagination,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Tag.name]: Tag,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Button,
        LSwitch
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.pagination.from - 1, this.pagination.to)
        },
        queriedData() {
            var self = this;
            let result = this.tableData
            if (this.searchQuery !== '') {
                result = result.filter(function (item) {
                    return item.code.toLowerCase().indexOf(self.searchQuery.toLowerCase()) > -1;
                });
            }
            self.pagination.total = result.length
            self.pagination.from = self.getFrom();
            self.pagination.to = self.getTo();
            return result.slice(this.pagination.from - 1, this.pagination.to);
        }
    },
    data() {
        return {
           
            searchQuery: '',
            propsToSearch: ['code'],
            tableColumns: [
                {
                    prop: 'code',
                    label: 'Code',
                    minWidth: 150
                },
                {
                    prop: 'percentage',
                    label: 'Percentage',
                    minWidth: 70
                },
                {
                    prop: 'amount',
                    label: 'Amount',
                    minWidth: 70
                },
                {
                    prop: 'defaultMaxUsing',
                    label: 'Max Using',
                    minWidth: 70
                },
                {
                    prop: 'isActiveString',
                    label: 'Is Active',
                    minWidth: 70
                },
                {
                    prop: 'description',
                    label: 'Description',
                    minWidth: 170
                }
            ],
            tableData: [],
            fuseSearch: null,
            isEditMode: false,
            isCreateMode: false,

            currentId: 0,
            currentCode: '',
            currentCodeBeforeEdit: '',
            currentPercentage: 0,
            currentAmount: 0,
            currentIsByAmount: false,
            currentDefaultMaxUsing: 0,
            currentDescription: '',
            currentIsActive: true,
            currentIsLimited: true,
            pagination: {
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
                from: 0,
                to: 0,
                perPage: 5
            }
        }
    },
    methods: {
        getFrom(total) {
            if (this.pagination.total == 0) {
                return 0;
            }
            return (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
        },
        getTo() {
            if (this.pagination.total == 0) {
                return 0;
            }
            if ((this.pagination.currentPage) * this.pagination.perPage > this.pagination.total) {
                return this.pagination.total;
            }
            return (this.pagination.currentPage) * this.pagination.perPage;
        },
        countEntranceCode() {
            var self = this;
            return this.tableData.filter(function (item) {
                return item.code == self.currentCode;
            }).length;
        },
        isSaveAllowed() {
            var result = true;

            if (this.isCreateMode) {
                if (this.countEntranceCode() > 0) {
                    this.notify("This discount code is already used. Please use another word.")
                    result = false;
                }
            }
            else
                if (this.isEditMode) {
                    if (this.currentCode != this.currentCodeBeforeEdit && this.countEntranceCode() > 0) {
                        this.notify("This discount code already used. Please use another word.")
                        result = false;
                    }
                }

            if (this.currentCode.length < 1 || this.currentCode.length > 30) {
                this.notify("Discount code field is invalid. Min length 1, max length 30.")
                result = false;
            }

            if (this.currentIsByAmount) {
                if (this.currentAmount < 1) {
                    this.notify("Discount amount is invalid. Min is €1.")
                    result = false;
                }
            }
            else {
                if (this.currentPercentage < 1 || this.currentPercentage > 100) {
                    this.notify("Percentage amount is invalid. Min is 1%, max is 100%.")
                    result = false;
                }
            }
            
            if (this.currentIsLimited && (this.currentDefaultMaxUsing <= 0 || this.currentDefaultMaxUsing > 999)) {
                this.notify("Default max using amount is invalid. Set value from 1 and less than 999.")
                result = false;
            }

            return result;
        },
        saveAddOrEdit() {
            if (!this.isSaveAllowed()) {
                return;
            }
            var data = {
                id: this.currentId,
                code: this.currentCode,
                description: this.currentDescription,
                isActive: this.currentIsActive
            }

            if (this.currentIsLimited && this.currentDefaultMaxUsing > 0) {
                data.defaultMaxUsing = this.currentDefaultMaxUsing;
            }

            if (this.currentIsByAmount) {
                data.amount = this.currentAmount;
            }
            else {
                data.percentage = this.currentPercentage;
            }
            var self = this;
            svc.addOrUpdateCouponCode(data).then(resp => {
                self.undoAnyMode();
                self.loadData();
                self.notify('Coupon code is saved', 'success', 'Success');
            }, resp => {
                //add catch
                self.undoAnyMode();
                self.notify('Coupon code was not saved. Something went wrong. Please try again...');
            });
        },
        setEditMode(index, row) {
            this.isEditMode = true;
            this.currentId = row.id;
            this.currentCode = row.code;
            this.currentCodeBeforeEdit = row.code;
            this.currentIsActive = row.isActive;
            if (row.percentage != null) {
                this.currentPercentage = row.percentage;
                this.currentIsByAmount = false;
            }
            else {
                this.currentAmount = row.amount;
                this.currentIsByAmount = true;
            }
            
            this.currentDescription = row.description;
            if (row.defaultMaxUsing != null) {
                this.currentDefaultMaxUsing = row.defaultMaxUsing;
                this.currentIsLimited = true;
            }
            else {
                this.currentIsLimited = false;
            }
            
        },
        setCreateMode() {
            this.isCreateMode = true;
            this.currentId = 0;
            this.currentCode = '';
            this.currentIsActive = true;
            this.currentPercentage = 10;
            this.currentAmount = null;
            this.currentDescription = '';
            this.currentDefaultMaxUsing = 100;
        },
        deleteRecord(index, row) {
            var self = this;
            swal({
                title: 'Warning!',
                text: 'You really want to delete this coupon code?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(function (result) {
                if (result.value == true) {
                    self.sendDeleteCouponCode(row.id)
                }
            });
        },
        sendDeleteCouponCode(id) {
            var self = this;
            self.currentId = id;
            svc.deleteCouponCode(id).then(function (response) {
                var result = response.body;
                var message = 'Unknown result. Try to reload page';
                if (result.message) {
                    message = result.message;
                }
                if (result != true) {
                    self.$notify({
                        title: "Error while deleting!",
                        message: 'Explanation: ' + message,
                        type: 'danger'
                    });
                    return;
                }
                let indexToDelete = self.tableData.findIndex((tableRow) => tableRow.id === self.currentId);
                if (indexToDelete >= -1) {
                    self.tableData.splice(indexToDelete, 1);
                }
                this.$notify({
                    title: "Success!",
                    message: 'Coupon code has been deleted.',
                    type: 'success'
                });
            }).catch(function () { });
        },
        loadData() {
            var self = this;
            svc.getCouponCodesList().then(function (resp) {
                var allData = resp.body;
                if (!allData.isSuccess) {
                    window.location.reload();
                    return;
                }
                self.tableData = allData.couponCodes;
                self.pagination.total = allData.couponCodes.length;
                self.pagination.from = self.getFrom();
                self.pagination.to = self.getTo();
            });
        },
        undoAnyMode() {
            this.isCreateMode = false;
            this.isEditMode = false;
        },
        notify(message, type, title) {
            if (!message) {
                message = 'Something went wrong!';
            }
            if (!type) {
                type = 'danger';
            }

            if (!title) {
                title = 'Oops!'
            }
            
            this.$notify({
                title: title,
                message: message,
                type: type
            });
        }
    },
    mounted() {
    },
    created() {
        this.loadData();
    }
}






// WEBPACK FOOTER //
// ./src/components/admin/coupons/coupons.js